export const AuthActionType = {
  ME: "me",
  HAS_ANSWER: "has_answer",
  ACCEPT: "accept_terms",
};
